import { useAccessTokenRoles } from '@b-stock/fe-core/bstock-next/components'
import { AnalyticsEntityType } from '@b-stock/fe-core/bstock-react'

export const useAnalyticsEntityType = (): AnalyticsEntityType => {
  const roles = useAccessTokenRoles()
  return roles?.seller ? AnalyticsEntityType.SELLER : AnalyticsEntityType.BUYER
}
